import React, { Fragment, useState } from "react"
import { Dialog } from "@headlessui/react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Transition } from "@headlessui/react"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

// Hero Section
const Hero = () => (
  <section className="grid 2xl:h66vh">
    <StaticImage
      src={"../../images/power-tool-hero.jpg"}
      alt=""
      aspectRatio={16 / 9}
      placeholder={"tracedSVG"}
      className="grid grid-1-1"
      style={{
        gridArea: "1/1",
      }}
      layout="fullWidth"
    />
    <div className="relative grid opacity-50 bg-gradient-to-l from-yellow-400 to-red-600 bg-opacity-90 grid-1-1" />
    <div className="relative grid grid-1-1 place-items-center ">
      <div className="w-full py-2 bg-gray-800 bg-opacity-90">
        <h1 className="m-auto text-2xl font-semibold text-transparent uppercase md:text-3xl bg-gradient-to-r from-yellow-400 to-red-600 bg-opacity-90 bg-clip-text fit-content">
          Household hardware <br />& Industrial Supplies
        </h1>
        <p className="m-auto text-white text-opacity-80 fit-content">
          From Home Projects to Supporting Large Industry,
          <br />
          <em className="font-semibold">Do It Best Industrial Supply</em> has
          you covered.
        </p>
      </div>
    </div>
  </section>
)
// (Services) Title Cards

const ServiceImage1 = () => (
  <StaticImage
    src="../../images/Paint-1.jpg"
    alt=""
    imgClassName="rounded-t-md"
    placeholder="blurred"
  />
)
const ServiceImage2 = () => (
  <StaticImage
    src="../../images/Paint-2.jpg"
    alt=""
    imgClassName="rounded-md"
    placeholder="blurred"
  />
)
const ServiceImage3 = () => (
  <StaticImage
    src="../../images/Tools-1.jpg"
    alt=""
    imgClassName="rounded-t-md"
    placeholder="blurred"
  />
)
const ServiceImage4 = () => (
  <StaticImage
    src="../../images/Tools-2.jpg"
    alt=""
    imgClassName="rounded-md"
    placeholder="blurred"
  />
)
const ServiceImage5 = () => (
  <StaticImage
    src="../../images/Yard-Supply-1.jpg"
    alt=""
    imgClassName="rounded-t-md"
    placeholder="blurred"
  />
)
const ServiceImage6 = () => (
  <StaticImage
    src="../../images/Yard-Supply-2.jpg"
    alt=""
    imgClassName="rounded-md"
    placeholder="blurred"
  />
)

const ServiceCard = ({
  title,
  subtitle,
  imgSrc,
  dialogTitle,
  dialogContent,
}) => {
  let [isOpen, setIsOpen] = useState(false)
  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  return (
    <>
      <div className="mx-4 mb-6 transition rounded-md shadow-lg md:m-4 hover:shadow-xl transform-gpu hover:-translate-y-1 motion-reduce:transition-none motion-reduce:transform-none">
        {imgSrc === "Img1" && <ServiceImage1 />}
        {imgSrc === "Img2" && <ServiceImage3 />}
        {imgSrc === "Img3" && <ServiceImage5 />}
        <div className="p-4">
          <h3 className="my-2 text-lg font-medium text-gray-800">{title}</h3>
          <p>{subtitle}</p>
          <button
            type="button"
            onClick={openModal}
            className="px-3 py-2 mt-5 font-semibold transition bg-red-500 rounded-full text-gray-50 text-opacity-95 hover:text-white hover:bg-red-800 transform-gpu motion-reduce:transition-none motion-reduce:transform-none hover:scale-105"
          >
            See More
          </button>
        </div>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            {/* Dialog Overlay */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-800 bg-opacity-40" />
            </Transition.Child>
            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            {/* Dialog Body */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h4"
                  className="mb-4 text-lg font-medium leading-6 text-gray-900"
                >
                  {dialogTitle}
                </Dialog.Title>
                {/* Dialog Content */}
                <div className="mt-2">
                  {imgSrc === "Img1" && <ServiceImage2 />}
                  {imgSrc === "Img2" && <ServiceImage4 />}
                  {imgSrc === "Img3" && <ServiceImage6 />}
                  <p className="mt-3 text-base text-gray-700">
                    {dialogContent}
                  </p>
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-yellow-900 bg-yellow-100 border border-transparent rounded-md hover:bg-yellow-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-yellow-500"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

const ServiceCards = () => (
  <section className="py-8 bg-white border-b sm:pt-0">
    <div className="container flex flex-wrap items-center justify-center pt-4 pb-12 mx-auto sm:flex-col-reverse">
      <h2 className="w-full my-2 text-3xl italic font-bold leading-tight text-center text-yellow-500">
        Tools & Supplies
      </h2>
      <div className="container flex px-5 py-24 mx-auto">
        <div className="flex flex-wrap justify-center -m-4">
          <div className="p-4 xl:w-1/3 md:w-1/2">
            <div className="p-6 border border-gray-200 rounded-lg shadow-md">
              <div className="inline-flex items-center justify-center float-left w-10 h-10 mb-4 mr-4 bg-red-500 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                  fill="currentColor"
                  width="20"
                  height="20"
                  className="w-6 h-6 text-white opacity-90"
                >
                  <path d="M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z" />
                </svg>
              </div>
              <h3 className="mb-2 text-lg font-medium text-gray-900 title-font ">
                Custom Industrial Supply Orders
              </h3>
              <p className="text-base leading-relaxed clear-left">
                Wether your job needs tools, or materials - we have access to a
                wide range of supplies that can meet any job specifications at a
                competitive price.
              </p>
            </div>
          </div>
          <div className="p-4 xl:w-1/3 md:w-1/2">
            <div className="p-6 border border-gray-200 rounded-lg shadow-md">
              <div className="inline-flex items-center justify-center float-left w-10 h-10 mb-4 mr-4 bg-red-500 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 58 55"
                  fill="currentColor"
                  className="w-6 h-6 text-white opacity-90"
                >
                  <path d="M40.271,39.021c-0.523,0-1.021-0.308-1.241-0.819L23.43,1.883c-0.294-0.685,0.022-1.479,0.707-1.773  c0.686-0.293,1.479,0.022,1.773,0.708L40.979,35.9l16.923-7.202c0.688-0.294,1.479,0.027,1.771,0.713  c0.292,0.687-0.026,1.479-0.713,1.77l-18.16,7.729C40.626,38.984,40.446,39.021,40.271,39.021z M50.556,12.714  c-0.292-0.686-1.086-1.005-1.771-0.712l-11.965,5.093c-0.687,0.293-1.005,1.086-0.714,1.771l5.569,13.085  c0.293,0.684,1.085,1.004,1.771,0.713l11.966-5.094c0.686-0.292,1.006-1.084,0.713-1.771L50.556,12.714z M23.622,41.459  c0,3.726,3.021,6.748,6.748,6.748c3.726,0,6.747-3.022,6.747-6.748c0-3.727-3.021-6.747-6.747-6.747  C26.643,34.712,23.622,37.732,23.622,41.459z M21.832,43.034h-9.526c0-3.927-3.184-7.111-7.112-7.111  c-2.052,0-3.896,0.874-5.193,2.265V27.265c0-0.745,0.604-1.35,1.35-1.35h2.157V10.796c0-0.932,0.755-1.687,1.687-1.687h17.684  c0.675,0,1.285,0.402,1.551,1.022l8.74,20.395c0.109,0.256,0.144,0.521,0.125,0.783c0,0.001,0,0.002,0,0.004v1.974  c-0.914-0.328-1.896-0.515-2.923-0.515c-4.798,0-8.688,3.889-8.688,8.687C21.682,41.998,21.738,42.522,21.832,43.034z   M18.914,29.964h10.344l-7.493-17.48H6.88v13.432h10.13L18.914,29.964z M0.021,43.034c0,2.857,2.315,5.173,5.172,5.173  s5.172-2.315,5.172-5.173c0-2.855-2.315-5.171-5.172-5.171S0.021,40.179,0.021,43.034z" />
                </svg>
              </div>
              <h3 className="mb-2 text-lg font-medium text-gray-900 title-font ">
                What can we deliver?
              </h3>
              <p className="text-base leading-relaxed clear-left">
                Any construction materials that you need, from pipe to rebar &
                nails to drivers. We can deliver it to your site, or package it
                for pickup at our location.
              </p>
            </div>
          </div>
          <div className="p-4 xl:w-1/3 md:w-1/2">
            <div className="p-6 border border-gray-200 rounded-lg shadow-md">
              <div className="inline-flex items-center justify-center float-left w-10 h-10 mb-4 mr-4 bg-red-500 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  fill="currentColor"
                  width="20"
                  height="20"
                  className="w-6 h-6 text-white opacity-90"
                >
                  <path d="M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z" />
                </svg>
              </div>
              <h3 className="mb-2 text-lg font-medium text-gray-900 title-font ">
                Who we supply
              </h3>
              <p className="text-base leading-relaxed clear-left">
                No job is too large or small for us to handle the material
                logistics for. We supply manufacturing sites, residential
                construction, and everything in between.
              </p>
            </div>
          </div>
          <div className="p-4 xl:w-1/3 md:w-1/2">
            <div className="p-6 border border-gray-200 rounded-lg shadow-md">
              <div className="inline-flex items-center justify-center float-left w-10 h-10 mb-4 mr-4 bg-red-500 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 15"
                  fill="currentColor"
                  width="20"
                  height="20"
                  className="w-6 h-6 text-white opacity-90"
                >
                  <path d="M15.929,7.743l-1.5-2.5A.5.5,0,0,0,14,5H11V3.5a.5.5,0,0,0-1,0V8H.5a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5H2.092a1.491,1.491,0,0,0,2.816,0h7.184a1.491,1.491,0,0,0,2.816,0H15.5a.5.5,0,0,0,.5-.5V8A.5.5,0,0,0,15.929,7.743ZM14.917,8H13V6h.717ZM3.5,12a.5.5,0,1,1,.5-.5A.5.5,0,0,1,3.5,12Zm10,0a.5.5,0,1,1,.5-.5A.5.5,0,0,1,13.5,12Z" />
                </svg>
              </div>
              <h3 className="mb-2 text-lg font-medium text-gray-900 title-font ">
                We're the right people to supply your job
              </h3>
              <p className="text-base leading-relaxed clear-left">
                Our experienced staff have the relationship, contacts, and skill
                to keep any your job productive at every milestone. Don't wait,
                contact us for fulfillment that satisfies.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container items-center mx-auto my-auto sm:flex sm:-mt-24">
        <ServiceCard
          title="Paint Products"
          subtitle="Glidden Paint, Rust-oleum, and more"
          imgSrc="Img1"
          dialogTitle="Do It Best Industrial Supply has all the paint and tools you need to prepare for your paint project."
          dialogContent="We can help you find the right products to help bring your project to life. Visit our store to speed up your job with our paint tools and make clean up easy with our preparation products. "
        />
        <ServiceCard
          title="Hand & Power Tools"
          subtitle="DeWalt, Milwaukee, Bostitch, Stanley, and more "
          imgSrc="Img2"
          dialogTitle="Each job requires the right tools, and that's all we carry."
          dialogContent="Do It Best Industrial Supply has a great selection of hand and power tools to meet all your repair and project needs. "
        />
        <ServiceCard
          title="Lawn & Garden Supplies"
          subtitle="Truper, Fiskars, Rubbermaid, True Temper, and more"
          imgSrc="Img3"
          dialogTitle="One stop for all yard care essentials"
          dialogContent="Do It Best Industrial Supply has all the supplies for pruning, planting, and weeding that you need to maintain the health of your garden and lawn."
        />
      </div>
    </div>
  </section>
)

const About = () => (
  <section className="py-8 bg-gray-100">
    <div className="container px-2 pt-4 pb-12 mx-auto text-gray-800">
      <h2 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
        About Do It Best Industrial Supply
      </h2>
      <div className="container flex flex-wrap px-5 py-12 mx-auto sm:flex-nowrap">
        {/* Map & Address Stuff */}
        <div className="relative flex items-end justify-start p-10 overflow-hidden bg-gray-300 rounded-lg lg:w-2/3 md:w-1/2 sm:mr-10">
          <iframe
            width="100%"
            height="100%"
            className="absolute inset-0"
            frameBorder="0"
            title="map"
            marginheight="0"
            marginwidth="0"
            scrolling="no"
            loading="lazy"
            src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=%C4%B0zmir+(Do%20It%20Best%20Industrial%20Supply)&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed"
            style={{ filter: "grayscale(1) contrast(1.2) opacity(0.4)" }}
          ></iframe>
          <div>
            <h3 className="mb-1 text-center text-white bg-gray-800 rounded text-shadow">
              Contact Us
            </h3>
            <address className="relative flex flex-wrap min-w-full py-6 bg-white rounded shadow-md">
              <div className="px-6 lg:w-1/2">
                <h4 className="text-xs font-semibold tracking-widest text-gray-900 title-font">
                  ADDRESS
                </h4>
                <p className="mt-1">
                  19310 HWY 43 <br />
                  Mt Vernon, AL 36560
                </p>
              </div>
              <div className="px-6 mt-4 lg:w-1/2 lg:mt-0">
                <h4 className="text-xs font-semibold tracking-widest text-gray-900 title-font">
                  EMAIL
                </h4>
                <a
                  href="mailto:industrialsupply.llc.com@gmail.com"
                  className="leading-relaxed tracking-tight text-red-500"
                >
                  industrialsupply.llc.com@gmail.com
                </a>
                <h4 className="mt-4 text-xs font-semibold tracking-widest text-gray-900 title-font">
                  PHONE
                </h4>
                <p className="leading-relaxed">251-829-4591</p>
              </div>
              <div className="w-full px-6 mt-4 lg:mt-0">
                <h4 className="mt-4 text-xs font-semibold tracking-widest text-gray-900 title-font">
                  Hours
                </h4>
                <div className="flex justify-between">
                  <span>M-F: 7-5</span>
                  <span>Sat & Sun: Closed</span>
                </div>
              </div>
            </address>
          </div>
        </div>
        {/* Side Content */}
        <div className="flex flex-col w-full px-3 mt-8 bg-white rounded-lg lg:w-1/3 md:w-1/2 md:ml-auto md:py-8 md:mt-0">
          <h3 className="mb-1 text-lg font-medium text-gray-900 title-font">
            Who we are
          </h3>
          <p className="mb-5 leading-relaxed text-gray-600">
            We are a <em>Do It Best</em> member-owned hardware, lumber, and
            building material store. From our base in Calvert, Alabama, we serve
            the growing residential, commercial, and industrial markets in North
            Mobile County.
          </p>
          <Link
            to="/about/"
            className="px-6 py-2 text-lg text-white bg-red-500 border-0 rounded focus:outline-none hover:bg-red-600"
          >
            The rest of the story...
          </Link>
        </div>
      </div>
    </div>
  </section>
)

const FeaturedBrand = () => (
  <section className="py-8 bg-gray-800">
    <div className="container flex flex-col-reverse px-4 pt-4 pb-12 mx-auto text-gray-100 md:flex-row">
      <StaticImage
        src="../../images/Glidden-Premium.jpg"
        alt=""
        imgClassName="rounded-md"
        placeholder="blurred"
      />
      <div className="flex flex-col items-center">
        <h2 className="my-2 text-5xl font-bold leading-tight text-center text-gray-100">
          Glidden Paint
        </h2>
        <StaticImage
          src="../../images/brand-logos/glidden-logo.png"
          alt=""
          imgClassName="rounded-md"
          placeholder="tracedSVG"
          className="w-2/3 mx-auto my-4 lg:w-1/2"
        />
        <p className="container pb-4 md:px-8">
          Glidden is the choice paint brand to provide great and quality paint
          at a fair price - since 1875. Glidden offers 100% acrylic interior &
          exterior paint in a variety of colors for every room in your house.
          From ceiling paint, to primer and spray paint - Glidden has got a
          product for your project.
        </p>
      </div>
    </div>
  </section>
)

const BrandCarousel = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }
  return (
    <Carousel
      responsive={responsive}
      swipeable={false}
      draggable={false}
      showDots={true}
      ssr={true}
      infinite={true}
      autoPlay={true}
      autoPlaySpeed={2000}
      keyBoardControl={false}
      transitionDuration={800}
      showDots={false}
      arrows={false}
      centerMode={true}
      className="py-4 overflow-hidden bg-white"
      sliderclassName="items-center inline-flex"
      sliderClass="items-center inline-flex"
    >
      <StaticImage
        src="../../images/brand-logos/liquid-wrench-logo-small.png"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
      <StaticImage
        src="../../images/brand-logos/igloo-logo.jpg"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
      <StaticImage
        src="../../images/brand-logos/Milwaukee-Logo.png"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
      <StaticImage
        src="../../images/brand-logos/stanley-logo.png"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
      <StaticImage
        src="../../images/brand-logos/CGW-Logo.jpg"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
      <StaticImage
        src="../../images/brand-logos/channel-lock-logo.png"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
      <StaticImage
        src="../../images/brand-logos/dewalt-logo.png"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
      <StaticImage
        src="../../images/brand-logos/gates-logo.png"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
      <StaticImage
        src="../../images/brand-logos/hougen-logo.jpg"
        alt=""
        className="mx-2"
        placeholder="tracedSVG"
        width="460px"
        objectFit="contain"
      />
    </Carousel>
  )
}

const Brands = () => (
  <section className="w-full pt-8 pb-0 border-b-2 bg-gray-50">
    <div className="container px-2 pt-4 pb-12 mx-auto text-gray-800">
      <h2 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
        Our Brands
      </h2>
    </div>
    <div className="px-2 pt-4 mx-auto text-gray-800">
      <BrandCarousel />
    </div>
  </section>
)

const Offerings = () => {
  return (
    <section className="container p-6 px-6 mx-auto bg-white dark:bg-gray-800">
      <div className="mb-16 text-center">
        <h2 className="text-base font-semibold tracking-wide text-yellow-500 uppercase">
          Services
        </h2>
        <p className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-white sm:text-4xl">
          We're here to help you
        </p>
      </div>
      <div className="flex flex-wrap my-12 dark:text-white">
        <div className="w-full p-8 border-b md:w-1/2 md:border-r lg:w-1/3">
          <div className="flex items-center mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="currentColor"
              className="w-6 h-6 text-yellow-500"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M15 21h-2v-3h-2v3H9v-2H7v2H4a1 1 0 0 1-1-1v-3h2v-2H3v-2h3v-2H3V9h2V7H3V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v9h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-3v-2h-2v2z" />
            </svg>
            <div className="ml-4 text-xl">Material Sizing</div>
          </div>
          <p className="leading-loose text-gray-500 dark:text-gray-200 text-md">
            Do It Best Industrial Supply can assist with cutting link chains,
            hoses, rope, cable, and wire.
          </p>
        </div>
        <div className="w-full p-8 border-b md:w-1/2 lg:w-1/3 lg:border-r">
          <div className="flex items-center mb-6">
            <svg
              width="20"
              height="20"
              fill="currentColor"
              className="w-6 h-6 text-red-500"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"></path>
            </svg>
            <div className="ml-4 text-xl">CUSTOM MATERIAL ORDERS</div>
          </div>
          <p className="leading-loose text-gray-500 dark:text-gray-200 text-md">
            With over 40 years of experience sourcing industrial materials, we
            have the relationships to get anything you can think of like rebar,
            power tools, lumber, plywood, concrete, structural steel, or sheet
            metal for example.
          </p>
        </div>
        <div className="w-full p-8 border-b md:w-1/2 md:border-r lg:w-1/3 lg:border-r-0">
          <div className="flex items-center mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
              fill="currentColor"
              className="w-6 h-6 text-yellow-500"
              width="20"
              height="20"
            >
              <title>delivery-truck</title>
              <path d="M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z" />
              <rect
                width="32"
                height="32"
                fill="none"
                data-name="&lt;Transparent Rectangle>"
              />
            </svg>
            <div className="ml-4 text-xl">Loading & Delivery</div>
          </div>
          <p className="leading-loose text-gray-500 dark:text-gray-200 text-md">
            Build unique product titles and descriptions instead of spending
            days manually editing each product.
          </p>
        </div>
        <div className="w-full p-8 border-b md:w-1/2 lg:w-1/3 lg:border-r lg:border-b-0">
          <div className="flex items-center mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width="20"
              height="20"
              fill="currentColor"
              className="w-6 h-6 text-red-500"
            >
              <path d="M256,178.16c-42.921,0-77.841,34.92-77.841,77.841c0,42.921,34.92,77.841,77.841,77.841s77.841-34.92,77.841-77.841 S298.921,178.16,256,178.16z M256,303.977c-26.454,0-47.976-21.522-47.976-47.976s21.522-47.976,47.976-47.976 s47.976,21.522,47.976,47.976S282.454,303.977,256,303.977z" />
              <path d="M512,240.974v-24.536h-40.051c-0.605-3.335-1.288-6.65-2.046-9.941c7.204-5.768,12.868-13.313,16.412-22.026 c5.494-13.505,5.401-28.344-0.266-41.782l-9.534-22.607l-36.909,15.563c-1.346-2.049-2.726-4.078-4.138-6.078 c4.509-8.063,6.915-17.193,6.915-26.609c0-14.582-5.679-28.291-15.99-38.599l-17.348-17.353l-28.332,28.331 c-2.776-1.917-5.603-3.775-8.47-5.567c1.021-9.18-0.309-18.528-3.967-27.204c-5.664-13.436-16.222-23.863-29.731-29.357 l-22.727-9.243l-15.092,37.097c-2.397-0.497-4.803-0.953-7.215-1.369c-6.472-23.042-27.553-39.693-52.539-39.693h-24.536v40.051 c-3.35,0.609-6.683,1.295-9.991,2.057c-10.231-12.708-25.886-20.455-42.56-20.455c-7.304,0-14.436,1.445-21.196,4.297 l-22.609,9.532l15.563,36.911c-2.05,1.346-4.077,2.726-6.078,4.138c-8.063-4.509-17.193-6.915-26.609-6.915 c-14.581,0-28.29,5.678-38.6,15.989l-17.35,17.35l28.33,28.331c-1.918,2.776-3.775,5.603-5.567,8.47 c-1.982-0.219-3.979-0.33-5.985-0.33c-22.314,0-42.166,13.356-50.577,34.028l-9.244,22.727l37.098,15.093 c-0.496,2.396-0.953,4.802-1.369,7.215C16.651,224.961,0,246.042,0,271.028v24.536h40.051c0.605,3.334,1.288,6.651,2.045,9.941 c-7.203,5.767-12.866,13.312-16.411,22.026c-5.494,13.505-5.4,28.342,0.266,41.78l9.534,22.609l36.909-15.563 c1.346,2.05,2.726,4.077,4.138,6.078c-4.508,8.063-6.915,17.193-6.915,26.609c0,14.582,5.679,28.291,15.99,38.6l17.349,17.349 l28.33-28.328c2.778,1.918,5.603,3.774,8.471,5.567c-1.021,9.18,0.309,18.528,3.967,27.204 c5.663,13.435,16.222,23.861,29.729,29.356l22.729,9.246l15.092-37.1c2.397,0.497,4.803,0.954,7.215,1.37 c6.472,23.042,27.553,39.692,52.538,39.692h24.536v-40.051c3.35-0.609,6.683-1.295,9.991-2.057 c10.231,12.708,25.886,20.454,42.56,20.454c7.302,0,14.434-1.444,21.198-4.295l22.607-9.534l-15.563-36.909 c2.05-1.346,4.077-2.726,6.079-4.138c8.062,4.509,17.193,6.915,26.608,6.915c14.582,0,28.291-5.679,38.599-15.99l17.352-17.349 l-28.331-28.331c1.918-2.777,3.774-5.602,5.567-8.47c1.982,0.22,3.979,0.33,5.985,0.33c22.315,0,42.166-13.356,50.577-34.029 l9.244-22.727l-37.098-15.092c0.496-2.396,0.953-4.802,1.369-7.215C495.349,287.041,512,265.96,512,240.974z M256,363.707 c-59.389,0-107.706-48.317-107.706-107.706S196.611,148.296,256,148.296s107.706,48.317,107.706,107.706 S315.389,363.707,256,363.707z" />
            </svg>
            <div className="ml-4 text-xl">Lumber Cutting</div>
          </div>
          <p className="leading-loose text-gray-500 dark:text-gray-200 text-md">
            Not only do we carry the lumber for your home or construction
            projects, we can handle all your lumber cutting needs onsite so you
            can take home exactly what you need.
          </p>
        </div>
        <div className="w-full p-8 border-b md:w-1/2 md:border-r md:border-b-0 lg:w-1/3 lg:border-b-0">
          <div className="flex items-center mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="currentColor"
              className="w-6 h-6 text-yellow-500"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M10.313 11.566l7.94-7.94 2.121 2.121-1.414 1.414 2.121 2.121-3.535 3.536-2.121-2.121-2.99 2.99a5.002 5.002 0 0 1-7.97 5.849 5 5 0 0 1 5.848-7.97zm-.899 5.848a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.828 2.828z" />
            </svg>
            <div className="ml-4 text-xl">KEY CUTTING</div>
          </div>
          <p className="leading-loose text-gray-500 dark:text-gray-200 text-md">
            No need to drive to Mobile to get a key cut. We can quickly cut home
            or vehicle keys right here in North Mobile County.
          </p>
        </div>
        <div className="w-full p-8 md:w-1/2 lg:w-1/3">
          <div className="flex items-center mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width="20"
              height="20"
              fill="currentColor"
              className="w-6 h-6 text-red-500"
            >
              <path d="M180,0H30C13.447,0,0,13.462,0,30s13.447,30,30,30h150c16.553,0,30-13.462,30-30S196.553,0,180,0z" />
              <path d="M482,452H332c-16.553,0-30,13.462-30,30c0,16.538,13.447,30,30,30h150c16.553,0,30-13.462,30-30 C512,465.462,498.553,452,482,452z" />
              <path d="M256,150c-16.553,0-30,13.462-30,30v150c0,16.538,13.447,30,30,30s30-13.462,30-30V180C286,163.462,272.553,150,256,150z" />
              <path d="M180,165V90H30v75c0,74.73,51.756,138.553,120.099,158.401c0.3,0,0.901,0.298,1.201,0.298 c14.099,3.9,29.099,6.301,44.7,6.301V180C187.599,180,180,173.401,180,165z" />
              <path d="M361.901,186.599c-0.3,0-0.901-0.298-1.201-0.298c-14.099-3.9-29.099-6.301-44.7-6.301v150c8.401,0,16,6.599,16,15v77h150 v-77C482,265.163,425.479,205.063,361.901,186.599z" />
            </svg>
            <div className="ml-4 text-xl">PVC Cutting</div>
          </div>
          <p className="leading-loose text-gray-500 dark:text-gray-200 text-md">
            For your convenience, we offer PVC pipe cutting at our location from
            1/2" to 4" diameter size.
          </p>
        </div>
      </div>
    </section>
  )
}

const Home = ({ children }) => {
  return (
    <>
      <Hero />
      <ServiceCards />
      <Offerings />
      <About />
      <FeaturedBrand />
      <Brands />
    </>
  )
}

export default Home
